import gql from "graphql-tag";
import { fetchPolicy } from "../client.bootstrap";

const PRODUCT_VERSION_PAYLOAD = `{
    id
    versionType
    programDelivery
    comments
    screenSize
    aspectRatio
    videoFormat
    frameRate
    varispeedType
    varispeedPercent
    creditsRunTime
    creditsType
    creditsFormat
    creditsFullLength
    creditsFacility
    mainOnEnds
    rating
    timing
    mpaaDisclaimerNumber
    videoStandard
    mpaaDisclaimer
    wwodOpening
    isActive
    reel1
    reel2
    blackPad
    contentTotal
    totalRuntime
    segments
    breakCount
    breakLength
    status
    color
    hasAD
    versionName

    cannotRepurpose
    cannotRepurposeReason
    cannotRepurposeDate
    cannotRepurposeNotes

    amxt
    tvpgr
    vchip
    calmAudio
    offlineEditor

    createdOn
    remasteredOn
    updatedAt
    lastModifiedBy

    productVersionFileMetadata {
        type
        fileName
        elementNumber
        wlShortId
        language
        facility
        sourceVersion
        editorName
        approvalDate
        startDate
        endDate
        qcOperator
        qcDate
    }

    productVersionSourcesUsed {
        id
        sourceType
        fileName
        idType
        number
        language
    }

    licensedService {
        id
        customerName: name
    }

    attachments: productVersionAttachments {
        id
        name: fileName
        docType
    }

    legacyDocuments: productVersionLegacyDocuments {
        id
        fileName
        docType
        filePath
    }

    productVersionAudioChannelConfigs {
            id
            language
            name
            position
    }
}`;

export function productVersionListQuery(params) {
    return {
        fetchPolicy,
        query: gql`
            query($productId: ID!, $licensedServiceName: String, $versionType: VersionType, $status: ProductVersionStatus) {
                result: productVersions(productId: $productId, licensedServiceName: $licensedServiceName, versionType: $versionType, status: $status) ${PRODUCT_VERSION_PAYLOAD}
            }
        `,
        variables: params,
    };
}

export function productVersionDetailQuery(params) {
    return {
        fetchPolicy,
        query: gql`
            query($id: ID!) {
                result: productVersion(id: $id) ${PRODUCT_VERSION_PAYLOAD}
            }
        `,
        variables: params,
    };
}

export function productVersionAttachmentListQuery(params) {
    return {
        fetchPolicy,
        query: gql`
            query($id: ID!) {
                result: productVersion(id: $id) {
                    id
                    files: productVersionAttachments {
                        id
                        name: fileName
                        docType
                    }
                }
            }
        `,
        variables: params,
    };
}
